export default {
  dateDisplayFormat: "DD MMM, YYYY (HH:mm A)"
}